export default __webpack_public_path__ + "static/media/ORGANIZATIONAL MEETING OF BOD 20 April 2022.2fcbd0fd.pdf";